import { createContext, useState } from 'react';

export const TripContext = createContext();

export function TripProvider({ children }) {
    const [trip, setTrip] = useState([]);

    const addActivity = (activity) =>
        setTrip((prev) => [...prev, activity]);

    const removeActivity = (id) =>
        setTrip((prev) => prev.filter((a) => a.id !== id));

    return (
        <TripContext.Provider value={{ trip, addActivity, removeActivity }}>
            {children}
        </TripContext.Provider>
    );
}